import {VehicleCatalogueColorProperties} from './VehicleCatalogueColorProperties';
import {VehicleCatalogueEnumOption} from './VehicleCatalogueEnumOption';
import {VehicleCatalogueFuelTypeProperties} from './VehicleCatalogueFuelTypeProperties';
import {VehicleCatalogueProperties} from './VehicleCatalogueProperties';

export type VehicleCatalogueType = {
  batteryTypes: VehicleCatalogueProperties;
  batteryOwnershipTypes: VehicleCatalogueProperties;
  bodyColors: VehicleCatalogueProperties<VehicleCatalogueColorProperties>;
  busStyles: VehicleCatalogueProperties;
  carStyles: VehicleCatalogueProperties;
  caravanStyles: VehicleCatalogueProperties;
  colorTypes: VehicleCatalogueProperties;
  conditions: VehicleCatalogueProperties;
  costs: VehicleCatalogueProperties;
  doorCounts: VehicleCatalogueProperties;
  drives: VehicleCatalogueProperties;
  emissionClasses: VehicleCatalogueProperties;
  features: VehicleCatalogueProperties;
  featureCategories: VehicleCatalogueProperties;
  fuelTypes: VehicleCatalogueProperties<VehicleCatalogueFuelTypeProperties>;
  fuelUnits: VehicleCatalogueProperties;
  handDriveTypes: VehicleCatalogueProperties;
  hybridTypes: VehicleCatalogueProperties;
  interiorColors: VehicleCatalogueProperties<VehicleCatalogueColorProperties>;
  interiorMaterials: VehicleCatalogueProperties;
  sellerTypes: VehicleCatalogueProperties;
  serviceBooks: VehicleCatalogueProperties;
  serviceBookStates: VehicleCatalogueProperties;
  vehicleTypes: VehicleCatalogueEnumOption[];
  tireAspectRatios: VehicleCatalogueProperties;
  tireMakes: VehicleCatalogueProperties;
  treModels: VehicleCatalogueProperties;
  tireRimDiameters: VehicleCatalogueProperties;
  tierSeasons: VehicleCatalogueProperties;
  tireWidth: VehicleCatalogueProperties;
  transmissions: VehicleCatalogueProperties;
  chargingConnectorTypes: VehicleCatalogueProperties;
  motorcycleStyles: VehicleCatalogueProperties;
  semiTrailerStyles: VehicleCatalogueProperties;
  trailerStyles: VehicleCatalogueProperties;
  constructionMachineStyles: VehicleCatalogueProperties;
  agriculturalMachineStyles: VehicleCatalogueProperties;
  truckStyles: VehicleCatalogueProperties;
  semiTruckStyles: VehicleCatalogueProperties;
  vanStyles: VehicleCatalogueProperties;
};
